module.exports = "https://web-assets-production.autolist.com/_next/static/images/trending-coupes-5f39394668a9d3b3d4cfd029c2f8fbcb.jpg";